import {
    isMobile,
    isTablet,
    isMobileOnly,
    isIOS,
    isMacOs,
} from 'react-device-detect'

export const sleep = ms => {
    return new Promise(resolve => setTimeout(resolve, ms))
}

String.prototype.capitalize = function() {
    if (typeof this !== 'string') return ''
    return this.charAt(0).toUpperCase() + this.slice(1)
}

export const isIPad = isTablet && (isIOS || isMacOs)

export const isDesktop = !isMobile && !isTablet

export const isMobilePhone = !isDesktop && !isTablet

export const isMobileDeviceOnly = isMobileOnly //if device type is mobile , devices can also be smarttv, wearable, console,etc.

const handleMediaDevicesAPIForOldBrowsers = () => {
    // Older browsers might not implement mediaDevices at all, so we set an empty object first
    if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {}
    }

    // Some browsers partially implement mediaDevices. We can't just assign an object
    // with getUserMedia as it would overwrite existing properties.
    // Here, we will just add the getUserMedia property if it's missing.
    if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function(constraints) {
            // First get ahold of the legacy getUserMedia, if present
            var getUserMedia =
                navigator.webkitGetUserMedia || navigator.mozGetUserMedia

            // Some browsers just don't implement it - return a rejected promise with an error
            // to keep a consistent interface
            if (!getUserMedia) {
                return Promise.reject(
                    new Error('getUserMedia is not implemented in this browser')
                )
            }

            // Otherwise, wrap the call to the old navigator.getUserMedia with a Promise
            return new Promise(function(resolve, reject) {
                getUserMedia.call(navigator, constraints, resolve, reject)
            })
        }
    }
}

handleMediaDevicesAPIForOldBrowsers()

export const randomize = (min, max) =>
    Math.floor(Math.random() * (max - min) + min)

export const getRandomElementFromArray = arr =>
    arr[Math.floor(Math.random() * arr.length)]

const fallbackCopyTextToClipboard = text => {
    const textArea = document.createElement('textarea')
    textArea.value = text
    textArea.style.top = '0'
    textArea.style.left = '0'
    textArea.style.position = 'fixed'

    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
        const successful = document.execCommand('copy')
        const msg = successful ? 'successful' : 'unsuccessful'
        console.log('Fallback: Copying text command was ' + msg)
    } catch (err) {
        console.error('Fallback: Oops, unable to copy', err)
    }
    document.body.removeChild(textArea)
}

export const copyTextToClipboard = text => {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text)
        return
    }
    navigator.clipboard.writeText(text).then(
        function() {
            console.log('Async: Copying to clipboard was successful!')
        },
        function(err) {
            console.error('Async: Could not copy text: ', err)
        }
    )
}

export const deletePropertyFromObject = (key, { [key]: _, ...newObject }) => {
    return newObject
}
